export default "__VITE_ASSET__BMLknNOm__"